import React from "react";
import { useAppSelector } from "../../../../store";
import { formatFullCurrency } from "../../../../utils/formatting";

/**
 * Component for displaying ship statistics (cost and tonnage) between step navigation and content
 *
 * @component
 * @example
 * ```tsx
 * <ShipStatsDisplay />
 * ```
 */
export const ShipStatsDisplay: React.FC = () => {
  const stats = useAppSelector((state) => state.shipBuilder.shipStats);
  const shipSize = useAppSelector((state) => state.shipBuilder.shipSize);

  const totalCost = stats?.totalCost || 0;
  const tonnageUsed = stats?.totalWeight || 0;
  const totalTonnage = shipSize || 0;

  return (
    <div className="bg-gray-100 dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-lg p-2 mb-4 shadow-sm">
      <div className="flex gap-6 justify-center">
        {/* Total Cost Box */}
        <div className="bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg p-3 flex-1 max-w-sm">
          <div className="flex items-center justify-between">
            <h3 className="text-base font-semibold text-gray-800 dark:text-gray-200">
              Total Cost
            </h3>
            <div className="text-xl font-bold text-green-600 dark:text-green-400">
              {formatFullCurrency(totalCost)}
            </div>
          </div>
          <div className="text-xs text-gray-500 dark:text-gray-400 mt-1">Credits</div>
        </div>

        {/* Tonnage Used Box */}
        <div className="bg-white dark:bg-gray-700 border border-gray-300 dark:border-gray-600 rounded-lg p-3 flex-1 max-w-sm">
          <div className="flex items-center justify-between">
            <h3 className="text-base font-semibold text-gray-800 dark:text-gray-200">
              Volume Used
            </h3>
            <div className="text-xl font-bold text-blue-600 dark:text-blue-400">
              {tonnageUsed.toFixed(2)} tons
            </div>
          </div>
          <div className="text-xs text-gray-500 dark:text-gray-400 mt-1">
            of {totalTonnage.toFixed(2)} d-Tons available space
          </div>
        </div>
      </div>
    </div>
  );
};
